<template>
 <div class="col-12">
 <div class="search-padd">
    <div v-if="subscriptionLevels.length == 1 && sub_loading == false" class="alert alert-danger" style="margin-top: 10px;">Pricing is not assigned to this Account. Please select pricing from Affiliate Tab.</div>

    <div class="col-xs-12 col-12 col-md-12 override-padding unit-wrapper" id="normal-unit-table" v-if="!isCustomPlan">

        <div class="crm_admin_heading purchase-heading-bar">
            <div class="row">
                <div class="col-4 col-md-4">Unit Type</div>
                <div class="col col-md-1">Quantity</div>                    
                <div class="col-2 col-md-2 text-center">Price</div>
                <div class="col-2 col-md-2">Override Price</div>
                <div class="col-3 col-md-3 text-center">Sub Total</div>
            </div>
        </div>
        <div class="row res_content">
            <div class="col-4 col-md-4">
                <b-form-select class="custom-select billingInput" v-model="subscriptionId" :options="subscriptionLevels"
                v-validate="'required'"
                name="subscription"
                v-on:change="getPriceforSubscription(subscriptionId)"></b-form-select>
                <div v-if="verrors.firstByRule('subscription', 'required')" class="margin-bottom-5 validate-warning-msg">Unit Type is required</div>
            </div>
            <div class="col col-md-1">
                <input type="text" class="po_input"  v-model="unit" style="width: 50px;" v-on:blur="updateSubTotal()" v-validate="'required|numeric'" name="unit_no">
                <div v-if="verrors.firstByRule('unit_no', 'required')" class="margin-bottom-5 validate-warning-msg">Units is required</div>
                <div v-if="verrors.firstByRule('unit_no', 'numeric')" class="margin-bottom-5 validate-warning-msg">Units should be numeric</div>

            </div>
            <div class="col-2 col-md-2 text-center" v-if="selectedSubscriptionPrice != ''">${{selectedSubscriptionPrice}}</div>
            <div class="col-2 col-md-2 text-center" v-else></div>
            <div class="col-2 col-md-2">
                <span class="dollarsign">$</span>&nbsp;<input type="text" class="po_input" v-model="overrideSubscriptionPrice" v-on:blur="overridePriceSubTotal()" name="override_price">
                <div v-if="isNumericOnlyErrorMsg" class="margin-bottom-5 validate-warning-msg">Override price should be numeric</div>                
            </div>
            <div class="col-3 col-md-3 text-center" v-if="subscriptionTotal != ''">${{subscriptionTotal}}</div>
            <div class="col-3 col-md-3 text-center" v-else></div>
        </div>
    </div>

     <div class="col-xs-12 col-12 col-md-12 override-padding unit-wrapper" id="custom-unit-table" v-if="isCustomPlan">

        <div class="crm_admin_heading purchase-heading-bar">
            <div class="row">
                <div class="col-3 col-md-3">Unit Type</div>
                <div class="col-2 col-md-2"># of Mentors</div>
                <div class="col col-md-1">Quantity</div>
                <div class="col-2 col-md-2 text-center">Price</div>
                <div class="col-2 col-md-2">Override Price</div>
                <div class="col-2 col-md-2 text-center">Sub Total</div>
            </div>
        </div>
        <div class="row res_content">
            <div class="col-3 col-md-3">
                <b-form-select class="custom-select billingInput" v-model="subscriptionId" :options="subscriptionLevels"
                v-validate="'required'"
                name="subscription"
                v-on:change="getPriceforSubscription(subscriptionId)"></b-form-select>
                <div v-if="verrors.firstByRule('subscription', 'required')" class="margin-bottom-5 validate-warning-msg">Unit Type is required</div>
            </div>
            <div class="col-2 col-md-2">
                <input type="text" class="po_input"  v-model="maxMentors" style="width: 90px;"  name="unit" v-on:blur="validateMaxMentor()">
                <div v-if="isMaxMentorNumericOnly" class="margin-bottom-5 validate-warning-msg"># of Mentors should be numeric</div>
            </div>
            <div class="col col-md-1">
                <input type="text" class="po_input"  v-model="unit" style="width: 50px;" v-on:blur="updateSubTotal()" v-validate="'required|numeric'" name="custom_unit_no">
                <div v-if="verrors.firstByRule('custom_unit_no', 'required')" class="margin-bottom-5 validate-warning-msg">Units is required</div>
                <div v-if="verrors.firstByRule('custom_unit_no', 'numeric')" class="margin-bottom-5 validate-warning-msg">Units should be numeric</div>
            </div>
            <div class="col-2 col-md-2 text-center" v-if="selectedSubscriptionPrice != ''">${{selectedSubscriptionPrice}}</div>
            <div class="col-2 col-md-2 text-center" v-else></div>
            <div class="col-2 col-md-2">
                <span class="dollarsign">$</span>&nbsp;<input type="text" class="po_input" v-model="overrideSubscriptionPrice" v-on:blur="overridePriceSubTotal();" name="custom_override_price">
                <div v-if="isNumericOnlyErrorMsg" class="margin-bottom-5 validate-warning-msg">Override price should be numeric</div>
            </div>
            <div class="col-2 col-md-2 text-center" v-if="subscriptionTotal != ''">${{subscriptionTotal}}</div>
            <div class="col-3 col-md-3 text-center" v-else></div>           
        </div>
    </div>       
    <div style="clear: both;"></div>


<div class="row pay_detail_row mt-3">
    <div class="col-md-6" id="pay_detail_row">
        <div class="card card_info">
            <div class="card-header purchasing_header">
                <div class="card-title purchase_title">Secure Payment</div>
            </div>
            <div class="card-body purchasing_body" id="billing_form_cc">
                <form id="card_form" class="mt-2" autocomplete="off">
                    <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <div class="radio">
                                <label class="radio_input">
                                    <input type="radio"  value="credit_card" v-validate="'required'" v-model="paymentMethod" name="payment_method" v-on:click="choosePaymentMode">&nbsp;Credit Cards (Process Online)
                                </label>
                                <div v-if="verrors.firstByRule('payment_method', 'required')" class="margin-bottom-5 validate-warning-msg">You must choose a payment method</div>
                                <div id="card_info" class="payment_mode_opt" style="display: block;">
                                    <div class="form-group row">
                                        <label for="card_no" class="col-sm-3 col-md-3 col-form-label">Name on Card:</label>
                                        <div class="col-sm-9  col-md-9">
                                            <input type="text" class="form-control billingInput" name="name_on_card" v-model="nameOnCard" v-validate=" isCCRequired ? 'required' : '' "  :disabled="isCreditPanel">
                                            <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="card_no" class="col-sm-3 col-md-3 col-form-label">Card Number:</label>
                                        <div class="col-sm-9  col-md-9">
                                            <input type="text" class="form-control billingInput" name="card_no" v-model="cardNumber" v-validate=" isCCRequired ? 'required' : '' " :disabled="isCreditPanel">
                                            <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="exp_month" class="col-form-label col-md-3">Expiration Date:</label>
                                       
                                            <select class="custom-select card_exp" name="exp_month" style="margin-left: 15px; width:70px; " v-model="expMonth" v-validate=" isCCRequired ? 'required' : '' " :disabled="isCreditPanel">
                                                <option value="">MM</option>
                                                <option value="01">01</option>
                                                <option value="02">02</option>
                                                <option value="03">03</option>
                                                <option value="04">04</option>
                                                <option value="05">05</option>
                                                <option value="06">06</option>
                                                <option value="07">07</option>
                                                <option value="08">08</option>
                                                <option value="09">09</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                            </select>
                                            <span style="margin-top: 10px;">&nbsp;&nbsp;/&nbsp;&nbsp;</span>

                                            <b-form-select
                          class="custom-select card_exp"
                          name="exp_year" v-model="expYear" v-validate=" isCCRequired ? 'required' : '' " style="width:70px; "
                          :options="year_options" :disabled="isCreditPanel">
                          </b-form-select>
                                       
                                           <span> <label for="cvv" class="col-form-label col-md-1">CVV:</label></span>
                                            
                                           <input type="password" class="form-control billingInput col-md-2" name="cvv" v-model="cvvValue" v-validate=" isCCRequired ? 'required' : '' " :disabled="isCreditPanel" role="presentation"
                                           autoComplete="new-password">
                                        

                                            <img src="@/assets/CVV.png"  width="25" height="30" alt="CVV image" class="center" style="margin-top: 2px;">

                                           
                                       
                                    </div>
                                    <div class="form-group row">
                                        
                                        <div class="col-sm-1 col-1 p-0" id="card_img">
                                            
                                        </div>
                                    </div>
                                    <div>
                                     <span v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg" style="margin-left:120px;">Month is required</span>

                                     <span v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg" style="margin-left:10px;">Year is required</span>                                     

                                      <span v-if="verrors.firstByRule('cvv', 'required')" class="margin-bottom-5 validate-warning-msg" style="margin-left:10px;">CVV is required</span>
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="radio">
                                <label class="radio_input"><input type="radio" name="payment_method" v-on:click="choosePaymentMode" value="check" v-model="paymentMethod">&nbsp;Check (Mail In)</label>
                                <div id="check_info" class="payment_mode_opt" style="display: block;">
                                    <div class="form-group row">
                                        <label for="is_check_received" class="col-sm-3 col-form-label">Check Received:</label>
                                        <div class="col-sm-9 pt-2">
                                            <input type="checkbox" id="is_check_received" ref="check_received_flag" value="1" v-model="checkReceived" @click="chooseCheckReceived($event)" :disabled="isCheckPanel">
                                            <div v-if="isCheckReceivedValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Received is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label for="check_no" class="col-sm-3 col-form-label">Check Number:</label>
                                        <div class="col-sm-9">
                                            <input type="text" class="form-control billingInput" id="check_no" v-model="checkNumber" name="check_number" v-on:blur="validateCheckNumber($event)" :disabled="isCheckPanel">
                                            <div v-if="isCheckNumberValidateMsg" class="margin-bottom-5 validate-warning-msg">Check Number is required</div>
                                            <div v-if="isCheckNumberNumericMsg" class="margin-bottom-5 validate-warning-msg">Check Number be numeric</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                </form>

            </div>
        </div>
        <div class="row justify-content-center">
    <button class="btn btn-primary customBtn mt-3" @click="processPayment()">Process Payment</button>
</div>
    </div>
    <div class="col-md-6" id="pay_detail_row">
        <div class="card billing_info">
            <div class="card-header purchasing_header">
                <div class="card-title purchase_title">Billing Information</div>
            </div>
            <div class="card-body purchasing_body">
                <form id="billing_form" class="mt-2" autocomplete="off">
                    <div class="form-group row">
                       
                            <input type="text" class="form-control billingInput" id="billing_admin" v-model="billingName" name="billing_name" v-validate="{ rules: { required: true} }" placeholder="Billing Name">
                            <div v-if="verrors.firstByRule('billing_name', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Name is required</div>
                    </div>
                    
                    <div class="form-group row">
                        <b-form-select
                          class="custom-select billingInput"
                          id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                          :options="country_options"
                          v-on:change="getStateLists(billingCountry)">
                          </b-form-select>
                            
                            <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                       
                    </div>
                    <div class="form-group row">
                        
                            <input type="text" class="form-control billingInput" name="billing_address_1" placeholder="Billing Address 1" v-model="billingAddress" v-validate="'required'" >
                            <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                    </div>
                    
                    <div class="form-group row">
                        
                            <input type="text" class="form-control billingInput" name="billing_address_2" placeholder="Billing Address 2" v-model="billingAddress2"  >
                    </div>
                    
                    <div class="form-group row">
                       
                            <input type="text" class="form-control billingInput" name="billing_city" placeholder="City" v-model="billingCity" v-validate="'required'">
                             <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                        
                    </div>
                    <div class="form-group row">
                             <b-form-select
                          class="custom-select billingInput"
                          name="billing_state" v-model="billingState" v-validate="'required'"
                          :options="state_options">
                          </b-form-select>

                            
                            <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                        
                    </div>
                    <div class="form-group row">

                            <input 
                            type="text" 
                            name="zip code" 
                            id="org_zip"
                            ref="org_zip"
                            v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                            v-model="billingZip"
                            maxlength="10"
                            class="form-control billingInput" 
                            placeholder="Zip">
                            <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>

                    </div>
                    <div class="form-group row">
                        <input 
                        type="text" 
                        name="phone number" 
                        id="phone_number"
                        ref="phone_number"
                        v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                        v-model="billingPhone"
                        @keyup="billingPhoneValid"
                        @blur="billingPhoneValid"
                        class="form-control billingInput" 
                        placeholder="Phone Number">
                        <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>                           
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<PurchaseModal 
          :isModalVisible="isPurchaseModalVisible" 
          :status="orderStatus" 
          :invoiceFilename="invoiceFilename"
          :orderId="orderId"
          @close="isPurchaseModalVisible = false"
          ref="admin_purchase_form">
</PurchaseModal>

 </div>
 </div>
</template>

<script>
import axios from 'axios';
import PurchaseModal from './admin_purchase_confirm.vue';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

export default {
 props: ['accountId'],
 data() {
 return {
     subscriptionLevels: [],
     subscriptionId: null,
     selectedSubscriptionPrice: '',
     unit: 1,
     licenseType: '',
     minQty: 1,
     subscriptionTotal: '',
     overrideSubscriptionPrice: '',
     billingName: '',
     billingAddress: '',
     billingAddress2: '',
     billingCity: '',
     billingState: '',
     billingCountry: '',
     billingZip: '',
     billingPhone: '',
     paymentMethod: '',
     nameOnCard: '',
     cardNumber: '',
     expMonth: '',
     expYear: '',
     cvvValue: '',
     checkNumber: '',
     checkReceived: false,
     isCCRequired: 0,
     country_options: [],
     state_options: this.state_options = [{ value: '', text: 'Select State' }],
     year_options: [],
     maxMentors: 0,
     isPurchaseModalVisible: false,
     invoiceFilename: '',
     orderId: '',
     orderStatus: '',
     isNumericOnlyErrorMsg: false,
     isMaxMentorNumericOnly: false,
     isCustomPlan: false,
     subscriptionIds: [],
     isCheckReceivedValidateMsg: false,
     isCheckNumberValidateMsg: false,
     isCheckNumberNumericMsg: false,
     isCheckPanel: true,
     isCreditPanel: false,
     sub_loading: false,
 }
 },
 components: {
         PurchaseModal,
 },
 methods: {
    billingPhoneValid: function(event) {
        var billing_phone = this.billingPhone;
        this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    phoneRegex: function() {
        return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    },
    getPostalCodeRegex: function() {
        if (this.billingCountry == "US") {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        } else if (this.billingCountry == "CA") {
            return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
        }
        return /./;
    },
   getPriceforSubscription: function(subscriptionSelected) {
    var planName = this.subscriptionIds[subscriptionSelected].toLowerCase();
     this.overrideSubscriptionPrice = '';
     this.licenseType = '';
     this.unit = 1;
     this.minQty = 1;
     this.isNumericOnlyErrorMsg = false;
     this.isMaxMentorNumericOnly = false;
     if(planName == 'custom') {
        this.isCustomPlan = true;
     } else {
        this.isCustomPlan = false;
     }
     axios('/lookups-active-subscriptions/' + this.accountId + '/' + subscriptionSelected,
          {
            method: 'GET',
          }
        )
        .then(resp => {
            this.selectedSubscriptionPrice = resp.data[0].price;
            this.licenseType = resp.data[0].licenseType;
            this.unit = resp.data[0].minQty;
            this.minQty = resp.data[0].minQty;
            if (this.overrideSubscriptionPrice == "") {
                if(this.licenseType == 'Bundle License') {
                    this.subscriptionTotal = this.selectedSubscriptionPrice;
                }
                else {
                    this.subscriptionTotal = this.unit * this.selectedSubscriptionPrice;
                }
                
            }
            else {
                this.subscriptionTotal = this.unit * this.overrideSubscriptionPrice;
            }
          })
        .catch(error => {

        });
   },
   updateSubTotal() {
        if(this.unit < this.minQty) {
            alert("Quantity should be equal or greater than " + this.minQty);
            this.unit = this.minQty;
        }
        this.isNumericOnlyErrorMsg = false;
        this.isMaxMentorNumericOnly = false;
        if((this.unit > 0) && (this.subscriptionId)) {
            axios('/getsubscriptionPrice',
              {
                method: 'GET',
                params: {
                  subscriptionId: this.subscriptionId,
                  qty: this.unit,
                  accountId: this.accountId,
                }
              }
            )
            .then(response => {
                this.selectedSubscriptionPrice = response.data;
                if (this.overrideSubscriptionPrice == "") {
                    if(this.licenseType == 'Bundle License') {
                        this.subscriptionTotal = this.selectedSubscriptionPrice;
                    }
                    else {
                        this.subscriptionTotal = this.unit * this.selectedSubscriptionPrice;
                    }
                    
                }
                else {
                    this.subscriptionTotal = this.unit * this.overrideSubscriptionPrice;
                }

              })
            .catch(error => {

            });
        }
   },
   overridePriceSubTotal() {
        if (this.overrideSubscriptionPrice == "") {
            if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = this.selectedSubscriptionPrice;
            }
            else {
                this.subscriptionTotal = this.unit * this.selectedSubscriptionPrice;
            }
        } else {
            this.isNumericOnlyErrorMsg = false;
            const pattern = /^\d*$/;
            if (!pattern.test(this.overrideSubscriptionPrice)) {
                this.isNumericOnlyErrorMsg = true;
                this.overrideSubscriptionPrice = "";
                this.subscriptionTotal = "";
                if (this.subscriptionId) {
                    this.subscriptionTotal = this.unit * this.selectedSubscriptionPrice;
                }
            } else {
                this.subscriptionTotal = this.unit * this.overrideSubscriptionPrice;
            }
        }
   },
   validateMaxMentor() {
        this.isMaxMentorNumericOnly = false;
        const pattern = /^\d*$/;
        if (!pattern.test(this.maxMentors)) {
            this.isMaxMentorNumericOnly = true;
            this.maxMentors = 0;
        }
   },
   processPayment() {
      this.$validator.validateAll().then((result) => {
             if ((this.verrors.items.length === 0) && this.validateCheckReceived()) {
                this.isPurchaseModalVisible = true;
                axios('/orders',
                    {
                    method: 'POST',
                    data:
                        {
                        subscription_id: this.subscriptionId,
                        units: this.unit,
                        override_price: this.overrideSubscriptionPrice,
                        subscription_price: this.selectedSubscriptionPrice,
                        subscription_total: this.subscriptionTotal,
                        account_id: this.accountId,
                        billing_name: this.billingName,
                        billing_address: this.billingAddress,
                        billing_address2: this.billingAddress2,
                        billing_city: this.billingCity,
                        billing_state: this.billingState,
                        billing_country: this.billingCountry,
                        billing_zip: this.billingZip,
                        billing_phone: this.billingPhone,
                        payment_method: this.paymentMethod,
                        name_oncard: this.nameOnCard,
                        card_number: this.cardNumber,
                        exp_month: this.expMonth,
                        exp_year: this.expYear,
                        cvv_value: this.cvvValue,
                        check_number: this.checkNumber,
                        check_received: this.checkReceived,
                        },
                    }
                    )
                    .then((resp) => {                  
                    document.getElementById("payment_loader").style.display = 'none';
                    document.getElementById("success_payment").style.display = 'block';
                    if(resp.data.msg == 'success') {
                        this.invoiceFilename = resp.data.invoice_filename;
                        this.orderId = resp.data.order_id;
                        this.orderStatus = resp.data.msg;
                    }
                    else {
                        this.orderId = resp.data.order_id;
                        this.orderStatus = resp.data.msg;
                    }
                    
                    this.subscriptionId = 'null';
                    this.unit = '1';
                    this.overrideSubscriptionPrice = '';
                    this.selectedSubscriptionPrice = '';
                    })
                    .catch(error => {
                    });  
             }
            })
            .catch(() => {

            });     
   },
   getCountryLists: function () {
          axios.get('/get-country-lists', {

          })
          .then(response =>  {
            this.country_options = response.data;
          })
          .catch(function(error) {

          });
    },
    getStateLists: function (CountryCode, index) {
          this.billingState = "";
          this.state_options = [
            { value: '', text: 'Select State' },
          ];
          if(CountryCode == '') {
            CountryCode = null;
          }
          axios.get('/get-state-lists/' + CountryCode, {

          })
          .then(response =>  {
            this.state_options = response.data;
          })
          .catch(function(error) {

          });
    },
    getExpiryYears() {       
        var d = new Date();
        var start_year = d.getFullYear().toString().substr(-2)
        var end_year =  parseInt(start_year) + 20;
        //alert(end_year)

        this.year_options = [
            { value: '', text: 'YY' },
          ];
        for(var i=start_year;i<=end_year;i++) {
            var yoptions = { value: i, text: i };
            this.year_options.push(yoptions);
        }        
    },
   choosePaymentMode(event) {
    if(event.target.value == 'credit_card') {
        this.isCCRequired = 1;
        this.isCheckNumberValidateMsg = false;
        this.isCheckNumberNumericMsg = false;
        this.isCheckPanel = true;
        this.isCreditPanel = false;
    }
    else {
        this.isCCRequired = 0;
        this.isCheckPanel = false;
        this.isCreditPanel = true;
    }
   },
   chooseCheckReceived(event) {
       if (event.target.checked) {
            this.isCheckReceivedValidateMsg = false;
            if (this.checkNumber == '') {
                this.isCheckNumberValidateMsg = true;
                this.isCheckNumberNumericMsg = false;
            }
       } else {
           this.isCheckNumberValidateMsg = false;
       }
   },
   validateCheckNumber(event) {
        const pattern = /^\d*$/;
        if (this.checkNumber == '') {
            this.isCheckNumberValidateMsg = false;
            this.isCheckReceivedValidateMsg = false;
        } else {
            if (!pattern.test(this.checkNumber)) {
                this.checkNumber = '';
                this.isCheckNumberNumericMsg = true;
                this.isCheckNumberValidateMsg = false;
            } else {
                this.isCheckNumberNumericMsg = false;
                this.isCheckNumberValidateMsg = false;
                if (!this.checkReceived) {
                    this.isCheckReceivedValidateMsg = true;
                }
            }
        }
   },
    validateCheckReceived() {
        var isFormSubmit = false;
        if (!this.checkReceived && this.checkNumber == '') {
            isFormSubmit = true;
        } else {
            if (this.checkReceived && this.checkNumber == '') {
                this.isCheckNumberValidateMsg = true;
                this.isCheckNumberNumericMsg = false;
                isFormSubmit = false;
            } else {
                const pattern = /^\d*$/;
                if (!pattern.test(this.checkNumber)) {
                    this.isCheckNumberNumericMsg = true;
                    this.isCheckNumberValidateMsg = false;
                    isFormSubmit = false;
                } else {
                    if (!this.checkReceived) {
                        isFormSubmit = false;
                    } else {
                        isFormSubmit = true;
                    }
                }
            }
        }
        return isFormSubmit;
    }
 },
 created: function () {
    this.sub_loading = true;
     axios('/active-subscriptions/' + this.accountId + '/Single',
          {
            method: 'GET'
              
          },
        )
        .then(response => {
           var subscriptionone =  { value: null, text: 'Please select' };
           this.subscriptionLevels.push(subscriptionone);
           for(var i=0; i < response.data.length; i++) {
             var subscription = {value: response.data[i].id, text: response.data[i].name};
              this.subscriptionLevels.push(subscription);
              this.subscriptionIds[response.data[i].id] = response.data[i].name;
            }
            this.sub_loading = false;
         })
        .catch(error => {

        });
        this.getCountryLists();
        this.getExpiryYears();
 }
 }
</script>

<style>
.purchase-heading-bar {
  width:100%;
}
.pay_detail_row {
    padding: 1rem !important;
}

/* CUSTOM CSS FOR CARD */
.card_info, .billing_info {
    
    border: 1px solid #b6b6b6;
    border-top: none;
}
.purchasing_body {
    min-height: 100px;
    padding: 15px;
}
.purchasing_header{
    padding: 0px !important;
    border-bottom: 0px !important;
}
.card-title {
    padding: 8px;
    font-weight: bold;
}


/* CUSTOM CSS FOR CARD TITLE AND HEADING */
.purchase_title {
    background-color: #00ACEE !important;
    color: #FFFFFF !important;
}
.purchase .res_heading {
    background-color: #ADBCB7 !important;
}
.shopping_title {
    background-color: #ADBCB7 !important;
}
.shopping .res_heading {
    background-color: #DC2128 !important;
    color: #FFFFFF !important;
}
.res_heading {
    font-weight: bold;
    padding: 8px;
}
.res_content {
    padding: 3px 5px 3px 5px;
    border-bottom: 1px solid #dee2e6;
}


/* CUSTOM CSS FOR BUTTONS AND ICONS */
.customBtn {
    background-color: #00ACEE !important;
    border-color: #00ACEE !important;
    border-radius: 0px;
    font-size: 13px !important;
    line-height: 15px;
    margin-bottom: 20px;
    padding: 5px 35px 5px 35px;
}
#card_img svg {
    width: 1.5rem;
    height: 2rem;
}

/* CUSTOM CSS FOR INPUT */
.po_input{
    width: 70px;
    margin-bottom: 5px;
}
.card_exp {
    display: inline-block;
}
.payment_mode_opt .custom-select {
    font-size: 13px;
    font-weight: normal;
    background-color: #EBEBEB;
}
.billingInput {
    font-size: 12px !important;
}
.radio_input {
    font-weight: bold;
    font-size: 12px;
}
.payment_mode_opt {
    margin: 0px 0px 0px 30px;
}


/* CUSTOM CSS FOR LABLE AND TEXT */
#total_text {
    font-weight: bold;
    text-transform: uppercase;
}
#priceAmt {
    color: #DC2128;
    font-weight: bold;
    margin-left: 40px;
}
.col-form-label {
    font-size: 12px !important;
}
#card_form .col-form-label{
    white-space: nowrap !important;
    text-align: left !important;
}
#billing_form .col-form-label{
    white-space: nowrap !important;
    text-align: right !important;
    font-weight: bold;
    font-size: 12px;
}


/* Large devices (laptops/desktops, 992px and up) 
@media only screen and (min-width: 992px) {
    .card_exp {
        width: 173px !important;
    }
}


@media only screen and (min-width: 1200px) {
    .card_exp {
        width: 173px !important;
    }
}


@media only screen and (min-width: 768px) {
    .card_exp {
        width: 229px !important;
    }
} */

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    body {
        font-size: 12px;
    }
    .cartBtn {
        font-size: 11px !important;
        padding: 0px 5px !important;
    }
    #sc_grid{
        overflow: auto;
    }
    #pc_grid {
        overflow: auto;
        white-space: nowrap;
    }
    .pay_detail_row {
        padding: 0rem !important;
    }
    .purchasing_header {
        height: 19px;
    }
    .card_exp {
        width: 62px;
    }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
    body {
        font-size: 12px;
    }
    .cartBtn {
        font-size: 11px !important;
        padding: 0px 5px !important;
    }
    #sc_grid{
        overflow: auto;
    }
    #pc_grid {
        overflow: auto;
        white-space: nowrap;
    }
    .pay_detail_row {
        padding: 0rem !important;
    }
    #billing_form .col-form-label {
        text-align: left !important;
    }
    .purchasing_header {
        height: 19px;
    }
    .card_exp {
        width: 190px;
    }
}

@media only screen and (max-width: 601px) {
    .card_exp {
        width: 162px !important;
    }
}
@media only screen and (max-width: 961px) {
    .col-md-6 {
        max-width: 100% !important;
        flex: 0 0 100% !important;
    }
}

#billing_form {
  margin: 0px 15px 0px 15px;    
}
.unit-wrapper {
  border: 1px solid #b6b6b6;
  border-top: none;
}
#billing_form .form-group, #billing_form_cc .form-group {
    margin-bottom: 5px;
}
#pay_detail_row .card-body {
    padding: 15px 15px 3px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_purchase_tab.vue